import { render, staticRenderFns } from "./share-component.vue?vue&type=template&id=786bd96c&scoped=true&lang=pug&"
import script from "./share-component.vue?vue&type=script&lang=js&"
export * from "./share-component.vue?vue&type=script&lang=js&"
import style0 from "./share-component.vue?vue&type=style&index=0&id=786bd96c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786bd96c",
  null
  
)

export default component.exports